
import { pluralize } from "@/store";
import { computed, defineComponent } from "vue";
export default defineComponent({
  props: ["count"],

  setup(props) {
    return {
      title: computed(() => {
        return pluralize("{count} {argument:count}", {
          count: props.count,
        });
      }),
    };
  },
});
